export default __webpack_public_path__ + "static/media/custom_fields.11cb35a5.png";